// extracted by css-extract-rspack-plugin
export default {"contentContainer":"ContentWrapper-module__contentContainer__IR2nYBK"};